import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { injectSiteProtocolVersions } from '@models/sites/api/sites.api';

import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '@shared/directives/noop-value-accessor.directive';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [NoopValueAccessorDirective],
  imports: [NgSelectModule, ReactiveFormsModule, TooltipDirective],
  selector: 'aux-protocol-version-dropdown',
  template: `
    <div class="min-w-52">
      <p class="mb-1 text-xs">{{ label() }}</p>
      <ng-select
        [formControl]="ngControl.control"
        [items]="protocolVersions.data()"
        [loading]="protocolVersions.isLoading()"
        [searchable]="true"
        [clearable]="clearable()"
        bindLabel="name"
        bindValue="id"
      >
        <ng-template ng-option-tmp let-item="item">
          <p
            class="truncate"
            #protocolVersionName
            [auxTooltip]="
              protocolVersionName.offsetWidth < protocolVersionName.scrollWidth ? item.name : ''
            "
          >
            {{ item.name }}
          </p>
        </ng-template>
      </ng-select>
    </div>
  `,
})
export class ProtocolVersionDropdownComponent {
  ngControl = injectNgControl();
  protocolVersions = injectSiteProtocolVersions();

  clearable = input(false);
  label = input('Protocol Version');
}
